import { BASE_URL } from "../constants"
import { Booking } from "../bookings/types"

// /mugshots/{id} is a stable URL and the response carries Last-Modified with no
// Cache-Control, so browsers apply heuristic freshness and reuse the image for days
// without revalidating. Appending the booking's token moves the cache key whenever the
// served photo changes, which is the only thing that evicts an already-cached copy.
export const mugshotUrl = (booking: Booking): string =>
  `${BASE_URL}mugshots/${booking.id}?v=${booking.mugshotToken}`
